$(function(){
  $('.product_listings_page .events-category-head').on('click', function(){
    let eventCategory = $(this).parent('.events-category');
    if(eventCategory.hasClass('non-foldable-category')) return; // Don't toggle Out of Stock categories
    let collapseCategoryEvents = $(this).next('.events-category-events');
    toggleCategory(eventCategory.attr('id'), !collapseCategoryEvents.hasClass('show'));
  });

  $(".category_filter a").on("click", function(e){
    $('.f-block-filter a').removeClass('active');
    let categoryId = $(this).attr("class");
    $(this).addClass('active');

    // Scroll to the top of the category (no matter if it's active or not)
    let filterBarHeight = $('.category_filter').outerHeight();
    $("html, body").animate({scrollTop: $("#" + categoryId).offset().top - filterBarHeight}, 100);
  });

  /*
   * Dynamic shadows for events scrolling in product info
   */
  $('.cro-template.product_info_page .content .events .events-categories-container, .travel-info #tickets-tab .col .events-container').on('scroll', function() {
    if($(this).prop('scrollHeight') > $(this).height()){
      $(this).next('.scrolling-shadow-bottom').show();
    }

    if($(this).scrollTop() > 10){
      $(this).prev('.scrolling-shadow-top').show();
    }
    else{
      $(this).prev('.scrolling-shadow-top').hide();
    }

    if($(this).scrollTop() > $(this).prop('scrollHeight') - $(this).height() - 10){
      $(this).next('.scrolling-shadow-bottom').hide();
    }
    else{
      $(this).next('.scrolling-shadow-bottom').show();
    }
  }).scrollTop(1).scrollTop(0); // Force scroll to trigger the listener and display the shadows and the scroll bar


  // Logic for toggling categories
  function toggleCategory(id, show = true){
    let eventCategory = $('.events-category#' + id + ' .events-category-events');

    if(show){
      eventCategory.slideDown('200ms').addClass('show');
    } else{
      eventCategory.slideUp('200ms', function(){
        $(this).removeClass('show');
      });
    }

    eventCategory.parent('.events-category').find('.events-category-toggle-button').toggleClass('open', show);
  }

  $("ul.tab li.tablinks:not(.download-link)").on("click", function(){

    $("ul.tab li.tablinks.active").each(function(){
      $(this).removeClass("active");
    });

    $(this).addClass("active");

    if($(this).hasClass("tab-highlighted")){
      $(this).removeClass("tab-highlighted");
      $(this).addClass("removed-tab-highlighting");
    }

    $(".active-tab").removeClass("active-tab").addClass("hidden-tab");

    $("div." + $(this).attr("id")).removeClass("hidden-tab").addClass("active-tab");

        /* Reset: Close information_paragraph that are already open when changing tabs */
        $(".foldout_faq.open").each(function() {
          $(this).find('.information_paragraph').toggle();
          $(this).removeClass("open");
    
          var img = $(this).find(".mlPlusMinIcons");
          if (img.attr('src') === '/media/icon-min.svg') {
              img.attr('src', '/media/icon-plus.svg');
          }
      });

    let scrollOffset = $('.active-tab').offset().top - $(this).parent('ul.tab').outerHeight()*2;
    $('html, body').animate({scrollTop: scrollOffset}, 'fast');

    $('.tabs-bottom-container').css('display', $(this).attr('id') === 'events' ? 'none' : 'flex');

    $("ul.tab li.tablinks:not(.active)").each(function(){
      if($(this).hasClass("removed-tab-highlighting")){
        $(this).removeClass("removed-tab-highlighting");
        $(this).addClass("tab-highlighted");
      }
    });

  });

  $(".information_title").on("click", function() {
    $("#" + $(this).attr("id") + ".information_paragraph").toggle();

    $(this).find("img").attr("src") === "/media/icon-plus.svg" ?
      $(this).find("img").attr("src", "/media/icon-min.svg") :
      $(this).find("img").attr("src", "/media/icon-plus.svg");

    $(this).toggleClass("open");
  });

  $(".foldout_faq").on("click", function() {
    $(this).find('.information_paragraph').toggle();
  });

  /*
     Click event listener targetting each element inside <li> tags with the "info" class within the "Choose Us" section
  */

  $(document).on('click', ".choose-us ul li.info, .benefits ul li.info, .choose-us-container ul li.info, .usps-foldables-container ul li.info, .hinweissText-notification", function(e) {
    e.preventDefault();
    $(this).children("#" + $(this).attr("id") + ".usp_paragraph").toggle();
  });

  //

  $('.ticket-modal').on('shown.bs.modal', function(){
    let modalHeight = $(this).height();
    let footerHeight = $(this).find('.modal-footer').outerHeight();
    // Set the height of the modal body to the height of the modal minus the height of the footer, so it'll stay "sticky"
    $(this).find('.modal-body').css('height', modalHeight - footerHeight + 'px');
  });

  $(".ticket-modal").on("hidden.bs.modal", function(){
    $("html").removeClass('model_pop_no_scroll');
  });

  $("section.open-ticket-modal").on("click", function(){

    var ticketModalId = $(this).attr("id");
    $("html").addClass('model_pop_no_scroll');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      {
        "event": "pdp_grandstand_modal",
        "pageType": "pdp-grandstand-modal",
        "grandstand": $(this).data("title") //dynamic value
      }
    );

    calculateTotal(ticketModalId);

    $(".modal-header-ajax").empty();

    $(".event-info-content").empty();
    $("#" + ticketModalId + ".event-info-content").addClass("shortened");
    $(".event-info-content").append('<div class="overlay"></div>');

    $.ajax({
      url: 'ajax_pro_att_slider.php',
      type: 'get',
      dataType: 'JSON',
      data: {
        id: ticketModalId,
        pro_id: $(".img_pr_id").val(),
        pro_op_id: $(".img_op_id").val(),
        img_pro_tmpl: $(".img_pro_tmpl").val(),
        img_pro_lng: $(".img_pro_lng").val(),
        img_pro_lng_id: $(".img_pro_lng_id").val()
      },
      success: function(response){
        var itemContainer = $("#ticket-modal-" + ticketModalId + " .modal-header-ajax");
        itemContainer.append(JSON.parse(JSON.stringify(response)));
        itemContainer.addClass('model_loaded');
        itemContainer.addClass('model_id_' + ticketModalId);
        var infoContent = itemContainer.find(".info-content");
        infoContent.remove();

        infoContent.find("button").remove();

        $("a.carousel-control").each(function(){
          if(!$(this).hasClass('left') && !$(this).hasClass('right')) return;

          const alt = $(this).data('alt');
          const src = $(this).hasClass('right') ? '/media/chevron-right-white.svg' : '/media/chevron-left-Carousel.svg';
          $(this).empty();
          $(this).append(`<img src="${src}" width="12" height="20" alt="${alt}" />`);
        });

        var itemMain = $("#ticket-modal-" + ticketModalId);
        var itemBody = $("#ticket-modal-" + ticketModalId + " .modal-body");
        var itemFooter = $("#ticket-modal-" + ticketModalId + " .modal-footer");
        itemBody.height(itemMain.height() - itemFooter.outerHeight());
      }
    });
  })

  $(".read-more-event-info-content").on("click", function(){
    toggleOverlay($(this).attr("id"));
  });

  function toggleOverlay(id){
    if($("#" + id + ".event-info-content").hasClass("shortened")){
      $("#" + id + ".event-info-content").removeClass("shortened");
      $(".event-info-content").find(".overlay").remove();
    }
    else{
      $("#" + id + ".event-info-content").addClass("shortened");
      $(".event-info-content").append('<div class="overlay"></div>');
    }
  }

  function calculateTotal(id) {

    let totalPrice = 0;

    $("#ticket-modal-" + id).find(".event-info").each(function() {
        let price = parseInt($(this).find(".new").text().replace('.', ''));
        let quantity = parseInt($(this).find(".number input").val());

        if (price && quantity) {
            totalPrice += price * quantity;
        }
    });

    $("#" + id + ".total_price").empty();
    $("#" + id + ".total_price").append(totalPrice + " " + $("#current_currency").val());
  }

  $(window).on('load', function(){
    $('.defer-imageload').each(function(){
      $(this).attr("src", $(this).attr("data-src"));
    });
  });

  $(window).scroll(function(){
    /** New category_filter scroll */
    if($(".category_filter").length){

      var filter_top = $(".content").offset().top;
      var max_filter_scroll = Math.round($(".events").height() + filter_top);
      var filter_height = Math.round($(".category_filter").outerHeight());

      var filter_diff = Math.round($(this).scrollTop() - max_filter_scroll);

      if($(this).scrollTop() < filter_top){
        $(".category_filter").css({'position': 'static', 'padding': ''});
      }

      if($(this).scrollTop() > filter_top){
        $(".category_filter").css({'position': 'sticky', 'padding': '10px 0'});
      }

      if($(this).scrollTop() > max_filter_scroll){

        if(filter_diff > filter_height){
          $(".category_filter").css({'position': 'static', 'padding': ''});
        }
        else{
          $(".category_filter").css({'position': 'sticky', 'padding': '10px 0'});
        }

      }
    }
    /** End New map scroll */
  });

  /**
   * Calculate the margin-top of the .right-container based on the first visible .event offset
   */
  function calcRightContainerMarginTop(){
    let firstVisibleEventOffset = $('.event:visible').first().parent().offset();
    let diff = firstVisibleEventOffset ? firstVisibleEventOffset.top - $('.left-container').offset().top : 0;
    let rightContainer = $('.right-container');
    if(!rightContainer.parents('.cro-template').is('.product_info_page, .product_listings_page')) // Don't apply this logic on product info and product listing page
      rightContainer.css('margin-top', Math.max(diff, 0) + 'px');
  }

  calcRightContainerMarginTop();

  // Display the Verbraucherschutz icon if the trust widget is not present
  let trustVerbraucherschutzWidget = $('.trust-verbraucherschutz-widget');
  if(trustVerbraucherschutzWidget.length === 0 || trustVerbraucherschutzWidget.is(':hidden')){
    $('.verbraucherschutz-icon').css('display', 'block');
  }

  // Toggle pages
  $(document).on('click', '.travel-info [data-toggle="page"]', function(){
    if($(this).attr('disabled')) return; // Support disabled also in non-buttons elements
    let targetPage = $(this).data('target');
    $('.active-page').removeClass('active-page').addClass('hidden-page');
    $('#'+targetPage).removeClass('hidden-page').addClass('active-page');
    // Scroll to the top of the travel info container
    $('html, body').animate({scrollTop: $('.travel-info').offset().top}, 'fast');

    if(targetPage !== 'travel-information-page' && $(this).data('no-history') !== true){
      // Append hash to the URL
      let pageHash = '#' + targetPage;
      if(window.location.hash !== pageHash){ // The page opened manually
        history.pushState(null, null, window.location.pathname + window.location.search + pageHash); // Append hash to the URL
      }
    } else if(targetPage === 'travel-information-page') {
      // Toggle the first step
      let firstStep = $('.travel-information-steps .step').first();
      $('<div class="step"></div>').attr('data-toggle', firstStep.data('toggle')).attr('data-target', firstStep.data('target'))
        .attr('data-no-page-toggling', true) // Prevent infinity loop of toggling the page
        .appendTo('.travel-info').trigger('click').remove();
    }
  });

  // Toggle tabs
  $(document).on('click', '.travel-info [data-toggle="tab"]', function() {
    if($(this).attr('disabled')) return; // Support disabled also in non-buttons elements

    if($(this).data('no-page-toggling') !== true && $('#travel-information-page.active-page').length === 0){
      // Trigger the page toggling
      $('<div></div>').attr('data-toggle', 'page').attr('data-target', 'travel-information-page')
        .attr('data-no-history', true) // Prevent pushing the page to the history
        .appendTo('.travel-info').trigger('click').remove();
    }

    let targetTab = $(this).data('target');
    $('.active-tab').removeClass('active-tab').addClass('hidden-tab');
    $('#'+targetTab).removeClass('hidden-tab').addClass('active-tab');
    // Scroll to the top of the travel info header
    $('html, body').animate({scrollTop: $('.travel-information-header-container').offset().top}, 'fast');

    // Append hash to the URL
    let tabHash = '#'+targetTab;
    if(window.location.hash !== tabHash){ // The tab opened manually
      history.pushState(null, null, window.location.pathname + window.location.search + tabHash); // Append hash to the URL
    }

    // Handle steps
    $('.step').removeClass('active done');
    let currentStep = $('.step[data-target="'+targetTab+'"]');
    currentStep.addClass('active');
    currentStep.prevAll('.step').addClass('done');
  });

  // Handle new travel ticket loading
  $('.new-travel-ticket').on('click', function(){
    const loader = $("#site-loader-bg");
    loader.fadeIn(300);
    $("body").toggleClass("loader-open");

    setTimeout(function(){
      $("#site-loader-txt-wait").fadeIn("slow");
    }, 3000);

    setTimeout(function(){
      $("#site-loader-txt-wait").fadeOut("slow", function(){
        $("#site-loader").fadeOut("slow", function(){
          $("#site-loader-container").addClass("loader-error");
        });
        $("#site-loader-txt-error").fadeIn("slow");
        $("#site-loader-txt-done").fadeIn("slow", function() {
          $("#site-loader-bg").hide();
          $("#site-loader-txt-error").hide();
        });
      });
    }, 30000);
  });

  // Open tickets by clicking on the circuit map
  $(document).on('mouseenter mouseleave click', '#image_map area', function(e) {
    let areaId = $(this).attr('class');
    let ticketContainer = $('.sm_bgd.' + areaId);

    if (ticketContainer.length) {
      if (e.type === 'mouseenter' && !ticketContainer.hasClass('out-of-stock'))
        $(this).css('cursor', 'pointer');
      else if (e.type === 'mouseleave')
        $(this).css('cursor', '');
      else if (e.type === 'click')
        ticketContainer.click();
    }
  });

  /* Expected date notice */
  $("#products-date-notice-info").on('click', function() {
    const drawerBg = $('.drawer-bg#products-text-date-background');
    drawerBg.fadeIn(300);
    drawerBg.find('.drawer').addClass('open');

    $('body').addClass('modal-open');
  });

  $('.close-drawer, .drawer-bg').on('click', function(e) {
    if($(this).hasClass('drawer-bg') && !$(e.target).is(this)) {
      return;
    }

    const drawerBg = $(this).closest('.drawer-bg');
    const drawer = drawerBg.find('.drawer');

    // Remove the 'open' class to trigger the slide-out animation
    drawer.removeClass('open');

    // Wait for the sliding-out animation to complete, then fade out the background
    setTimeout(function() {
      drawerBg.fadeOut(300);
      $('body').removeClass('modal-open');
    }, 300);
  });

  $('section.expected-date .expected-date-title-container').on('click', function() {
    $(this).next('.expected-date-description').slideToggle(100);
  });
  /* End Expected date notice */
});
